import ApplicationController from './application_controller';
import { isMobile } from 'mobile-device-detect';

export default class extends ApplicationController {
  // Define a fieldId value to reference the file input element
  static values = { fieldId: String }

  connect() {
    // Hide the "Take Picture" button on non-mobile devices
    if (!isMobile) {
      document.querySelector(`.mobile-take-picture-button`)?.classList?.add('hidden');;
    }
  }

  async capture() {
    // Only allow this on mobile and tablet devices
    if (!isMobile) {
      return;
    }
    try {
      // Request access to the user's camera
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      // Create a video element to show the live camera feed
      const video = document.createElement('video');
      video.srcObject = stream;
      video.play();
      // Create and display a modal for camera preview and buttons
      const modal = document.createElement('div');
      modal.classList.add('camera-modal');
      modal.innerHTML = `
        <div class="camera-preview"></div>
        <button class="btn btn-success mt-2">Capture</button>
        <button class="btn btn-secondary mt-2">Cancel</button>
      `;
      modal.querySelector('.camera-preview').appendChild(video);
      document.body.appendChild(modal);
      const captureButton = modal.querySelector('.btn-success');
      const cancelButton = modal.querySelector('.btn-secondary');
      // Handle capture button click
      captureButton.addEventListener('click', () => {
        // Draw the current frame from the video onto a canvas
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0);
        // Convert the canvas image to a blob and simulate a file input selection
        canvas.toBlob((blob) => {
          const fileInput = document.getElementById(this.fieldIdValue);
          const file = new File([blob], 'photo.jpg', { type: 'image/jpeg' });
          // Create a DataTransfer to simulate selecting a file
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(file);
          fileInput.files = dataTransfer.files;
          // Trigger the change event in case listeners are attached
          fileInput.dispatchEvent(new Event('change'));
          // Stop the camera and remove the modal
          stream.getTracks().forEach(track => track.stop());
          modal.remove();
        }, 'image/jpeg');
      });
      // Handle cancel button click
      cancelButton.addEventListener('click', () => {
        stream.getTracks().forEach(track => track.stop()); // Stop camera
        modal.remove(); // Remove the modal
      });
    } catch (error) {
      // Silence errors ~ usually the user is just being prompted for camera permissions
    }
  }
}
